// extracted by mini-css-extract-plugin
module.exports = {"item":"form_item__p5QB6","item_wrapper":"form_item_wrapper__g8yDZ","main_input":"form_main_input__EkK0R","errorTips":"form_errorTips__WnSjJ"};